import React from 'react';
import './PrintReport.css';

// Printer icon (same inline SVG as View)
const PrinterIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    width="20"
    height="20"
    aria-hidden="true"
  >
    <path d="M6 9V2h12v7" />
    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
    <rect x="6" y="14" width="12" height="8" />
  </svg>
);

const PrintReportEdit = () => {
  return (
    <div className="print-report-block print-report-block--edit">
      <PrinterIcon />
      <span>
        <strong>Print Report Block</strong> — renders a print button on the
        page. Configured in <code>src/index.js</code> and{' '}
        <code>PrintReport/print.config.js</code>.
      </span>
    </div>
  );
};

export default PrintReportEdit;
